import React, { useState, useEffect } from "react";
import {
  MULTI_CHOICE,
  RULE_SUGESSTION_OPTIONS,
  RULE_FEATURE_TYPE_OPTIONS,
  RULE_OPERATOR_OPTIONS,
  CREATE_NEW_CONDITION,
  RULE_VALIDATION_MESSAGE,
  RULE_NAME_MANDATORY_MESSAGE,
  RULE_SAVE_MESSAGE,
  RULE_UPDATE_MESSAGE,
  RULE_CONDITION,
  RULE_DONE,
  RULE_RULE,
  RULE_EXPRESSION,
  RULE_SELECT,
  RULE_OPERATOR,
  RULE_FUNCTION_SAVE,
  RULE_FUNCTION_EDIT,
  RULE_FUNCTION_DELETE,
  RULE_FUNCTION_RULE_NAME,
  RULE_NAME,
  RULE_DESCRIPTION,
  RULE_FEATURE_TYPE,
  RULE_FEATURE,
  RULE_FUNCTION_PARENT,
  RULE_FUNCTION_CONDITION,
  RULE_FUNCTION_EXPRESSION,
  RULE_FUNCTION_CHILD,
  RULE_FUNCTION_ADD,
  RULE_FUNCTION_0,
  RULE_FUNCTION_1,
  RULE_FUNCTION_2,
  RULE_FUNCTION_3,
  RULE_EMPTY_STRING,
  RULE_FUNCTION_SUBMODEL,
  RULE_FUNCTION_SUBMODEL_FIELD,
  RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
  RULE_FUNCTION_FIELD,
  RULE_FUNCTION_CATEGORY,
  RULE_FUNCTION_CONNECTOR,
  RULE_ADD_FIELD,
  RULE_FUNCTION_DESCRIPTION,
  RULE_STAR, RULE_SAVE, RANGE_FIELD,
} from "../../ISRConstants";
import MathOperator from "../MathOperator/mathOperatorComponent";
import SelectOptionsView from "../SelectOptionsView";
import { EditIcon, DeleteIcon } from "assests/GmsIcons";
import {
  RuleObjectStateType,
  RuleObjectType,
  TCategory,
  TRuleObj,
} from "../../Pages/DefineModel/model";
import { toast } from "react-toastify";
import {
  TConnector,
  TField,
  TFieldDataConfiguration,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
  TFieldAdditionalData,
  RuleSuggestionOptionType,
  RuleOptionType,
  TTransformation,
  TClass,
} from "../../Pages/DefineModel/model";
import { TAttributeChoice } from "types/Pages/ProductDelta";


type ConditionalRuleComponentPropType = {
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo?: TIndexState;
  editId?: any;
  ruleType: any;
  toggleMenu: () => void;
  createISRProject:(isRuleUpdate: boolean)=>void;
  featureType: string;
};

type commandType = {
  id: number;
  label: string;
  description: string;
  hasOptions: boolean;
  onClickHandler: Function;
  child: [];
  type: string;
  choiceType: string;
};

const ConditionalRuleComponent = ({
  selectedItem,
  setUserProjectDataModels,
  userProjectDataModels,
  indexInfo,
  editId,
  ruleType,
  toggleMenu,
  createISRProject,
  featureType,
}: ConditionalRuleComponentPropType) => {
  const [rules, setRules] = useState<RuleObjectStateType[]>([]);
  const [ruleState, setRuleState] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [conditionState, setConditionState] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [showMath, setShowMath] = useState<boolean>(false);
  const [dynamicCommandOption, setDynamicCommandOption] = useState<any[]>();
  const [commandOptions, setCommandOptions] = useState<
    RuleSuggestionOptionType[]
  >(RULE_SUGESSTION_OPTIONS);
  const [showSelectOptions, setShowSelectOptions] = useState<boolean>(false);
  const [selectRef, setSelectRef] = useState<any>();
  const [expressionRef, setExpressionRef] = useState<any>();
  const [conditionRef, setConditionRef] = useState<any>();
  const [ruleScope, setRuleScope] = useState<any>();
  const [propName, setPropName] = useState<string>(RULE_EMPTY_STRING);
  const [loading, setLoading] = useState<boolean>(false);
  const [mergeFieldList, setMergeFieldList] = useState<
    (
      | TField
      | {
          id: string | null | undefined;
          type: string;
          name: string;
          belongsToDataModel: boolean;
          dataConfiguration: TFieldDataConfiguration;
          additionalData: TFieldAdditionalData;
          rules: RuleObjectType[];
        }
    )[]
  >();
  const [ruleName, setRuleName] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [description, setDescription] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [dynamicFeatureOptions, setDynamicFeatureOptions] = useState<any[]>();
  const [stateFeatureType, setStateFeatureType] = useState<RuleOptionType>();
  const [feature, setFeature] = useState<RuleOptionType>();
  const [operator, setOperator] = useState<RuleOptionType>();
  const [activeInput, setActiveInput] = useState<string>();
  const [ruleExpList, setRuleExpList] = useState<TRuleObj[]>([]);
  const [hierarchyObject, setHierarchyObject] = useState<{ subModel: string, category: string, field: string }>({ subModel: "", category: "", field: "" });

  const setFocusToInput = (callType: string = RULE_FUNCTION_EXPRESSION) => {
    if (callType === RULE_FUNCTION_EXPRESSION)
      if (expressionRef) expressionRef.focus();
      else if (conditionRef) conditionRef.focus();
  };

  useEffect(() => {
    fetchEditState();
  }, [selectedItem, userProjectDataModels]);

  useEffect(() => {
    if (ruleState && ruleState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName(RULE_EMPTY_STRING);
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput();
  }, [ruleState]);

  useEffect(() => {
    if (conditionState && conditionState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName(RULE_EMPTY_STRING);
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput("condition");
  }, [conditionState]);

  useEffect(() => {
    scrollToBottom();
  }, [showSelectOptions, dynamicCommandOption, dynamicFeatureOptions]);

  const fetchEditState = () => {
    let prevRule: RuleObjectStateType | undefined;
    let prevRules: RuleObjectStateType[];
    let localFeature: TField | TProductCategory | undefined;
    if (
      selectedItem &&
      "belongsToDataModel" in selectedItem &&
      selectedItem?.belongsToDataModel
    ) {
      prevRules =
        userProjectDataModels?.project.dataModels[
          indexInfo?.dataModelIndex ?? -1
        ]?.data.fields[indexInfo?.fieldIndex ?? -1].rules ?? [];
      if(prevRules.length > 0) {
        prevRule = prevRules.find((e) => e.id === editId);
        if(prevRule?.featureType === 2) {
          const subModel = userProjectDataModels?.project.dataModels.find((e) => e.id === prevRule?.subModel);
          localFeature = subModel?.data.productCategories.find((e) => e.id === prevRule?.feature);
        }
      }
    } else {
      localFeature =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data;
      prevRules =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    }
    if (Array.isArray(prevRules)) {
      if (prevRules !== rules) setRules(prevRules);

      const localFeatureType = RULE_FEATURE_TYPE_OPTIONS.filter(
        (x) => x.id === prevRule?.featureType
      );
      setStateFeatureType(localFeatureType[0]);
      let fieldList;
      if(prevRule?.featureType === 2) {
        fieldList = getCategoryList();
      } else {
        fieldList = getFieldsList();
      }
      setDynamicFeatureOptions(fieldList);
      const localFeatureVal = fieldList.filter(
        (x) => x?.id === localFeature?.id
      );
      setFeature(localFeatureVal[0]);
      if (editId) {
        const ruleObj = prevRules.filter((rule: any) => {
          return rule.id === editId;
        });
        if (ruleObj?.length > 0) {
          const expList = (ruleObj[0]?.ruleExpList as TRuleObj[])?.map((x) => {
            if (x.ruleCondition && x.ruleExp) x.disabled = true;
            return x;
          });
          setRuleName(ruleObj[0]?.name);
          setDescription(ruleObj[0]?.description);
          setRuleScope(ruleObj[0]?.ruleScope);
          setRuleExpList(expList);
          const localOperator = RULE_OPERATOR_OPTIONS.filter(
            (x) => x.label === ruleObj[0].operator
          );
          setOperator(localOperator[0]);
        }
      } else {
        const expList = (
          prevRules[prevRules?.length - 1]?.ruleExpList as TRuleObj[]
        )?.map((x) => {
          if (x.ruleCondition && x.ruleExp) x.disabled = true;
          return x;
        });
        if (ruleName && ruleExpList) setRuleExpList(expList);
      }
    }
  };

  const scrollToBottom = () => {
    if (selectRef) selectRef.scrollIntoView({ behavior: "smooth" });
  };

  const getSubModelsList = () => {
    const localCommand = userProjectDataModels.project.dataModels.filter(
      (userProjectObject) => userProjectObject.type === RULE_FUNCTION_SUBMODEL
    );
    const retlocalCommand = localCommand.map((command) => {
      return {
        id: command.id,
        label: command.data.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL,
        type: command.type,
      };
    });
    return retlocalCommand;
  };

  const getSubModelsFieldsList = (id: any) => {
    let localFieldModel = userProjectDataModels?.project.dataModels.filter(
      (model) => model.id === id
    );
    let localFields = localFieldModel[0]?.data?.fields ?? [];
    let retlocalFields = localFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL_FIELD,
        type: command.type,
      };
    });
    return retlocalFields;
  };

  const getSubModelsFieldsChoiceList = (id: any) => {
    let localFields =
      mergeFieldList ??
      userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]
        ?.data.fields ??
      [];
    let subModel = userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.id
    let fieldObject = localFields.filter((x) => x.id === id);
    let optionToMap;
    if (fieldObject.length > 0) {
      optionToMap = fieldObject[0];
      let retlocalFields = optionToMap?.dataConfiguration?.choices?.map(
        (command: TAttributeChoice) => {
          return {
            id: command.av_id ?? command.id,
            label: command.av_value ?? command.value,
            description: RULE_EMPTY_STRING,
            hasOptions: false,
            child: [],
            choiceType: RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
            type: MULTI_CHOICE,
            field: id,
            subModel: subModel
          };
        }
      );
      return retlocalFields;
    }
  };

  const getFieldsList = () => {
    let localFields = userProjectDataModels?.project.fields ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id };
    });
    let submodelFieldList: TField[] = [];
    userProjectDataModels?.project?.dataModels?.forEach((subModels) => {
      submodelFieldList.push(
        ...subModels?.data?.fields?.map((y) => {
          const localObj = { ...y };
          localObj.name = `"${subModels.data.name}"."${y.name}"`;
          localObj.subModel = subModels?.id
          return localObj;
        })
      );
    });
    let mergeFields = [...newlocalFields, ...submodelFieldList];
    setMergeFieldList(mergeFields);
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_FIELD,
        type: command.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getCategoryList = () => {
    let localFields = userProjectDataModels?.project?.productCategories ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id, type: x.type };
    });
    let submodelCategoryList: {
      id: string | null | undefined;
      compatioScore: boolean;
      type: string;
      name: string;
      belongsToDataModel: boolean;
      categories: {
        type: string;
        data: TCategory[];
      };
      transformations: TTransformation[];
      subModel?: string | null | undefined;
    }[] = [];

    userProjectDataModels?.project?.dataModels?.map((subModels) => {
      subModels?.data?.productCategories?.forEach((y) => {
        const localObj = { ...y };
        submodelCategoryList.push({
          ...localObj.data,
          name: `"${subModels.data.name}"."${y.data.name}"`,
          id: localObj.id,
          subModel: subModels?.id
        });
      });
      return subModels;
    });
    let mergeFields = [...newlocalFields, ...submodelCategoryList];
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command?.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_CATEGORY,
        type: command?.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getConnectorList = () => {
    let localFields = userProjectDataModels?.project?.connectors ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id, type: x.type };
    });
    let submodelConnectorList: {
      id: string | null | undefined;
      type: string;
      name: string;
      isConsumable: boolean;
      belongsToDataModel: boolean;
      submodels: TClass[];
      subModel: string | undefined | null
    }[] = [];
    userProjectDataModels?.project?.dataModels?.forEach((subModels) => {
      subModels?.data?.connectors?.forEach((y) => {
        const localObj = { ...y };
        submodelConnectorList.push({
          ...localObj.data,
          name: `"${subModels.data.name}"."${y.data.name}"`,
          subModel: subModels?.id,
          id: localObj.id,
        });
      });
    });
    let mergeFields = [...newlocalFields, ...submodelConnectorList];
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command?.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_CONNECTOR,
        type: command?.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const updateRules = (localRules: RuleObjectStateType[]) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      const newRules: RuleObjectType[] = localRules.map((x) => {
        if (x.type === ruleType)
          return {
            id: x.id,
            ruleExpList: x.ruleExpList,
            ruleScope: x.ruleScope ?? {},
            name: x.name,
            description: x.description ?? RULE_EMPTY_STRING,
            type: x.type,
            operator: x?.operator,
            feature: x?.feature,
            featureType: x?.featureType,
            subModel: x?.subModel,
          };
        else return x;
      });
      if (
        selectedItem &&
        "belongsToDataModel" in selectedItem &&
        selectedItem?.belongsToDataModel
      ) {
        const dataModelToUpdate =
          newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
        if (
          dataModelToUpdate &&
          dataModelToUpdate.data &&
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]
        ) {
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1].rules =
            newRules;
        }
      } else {
        const fieldToUpdate =
          newDataModels.project.fields[
            indexInfo?.fieldOutsideDataModelIndex ?? -1
          ];
        if (fieldToUpdate && fieldToUpdate.data) {
          fieldToUpdate.data.rules = newRules;
        }
      }
      return newDataModels;
    });
  };

  const handleOptionsClick = (
    optionObject: commandType,
    callType: string = RULE_FUNCTION_EXPRESSION
  ) => {
    const rule = ruleState && ruleState.slice(0, -1);
    const condition = conditionState && conditionState.slice(0, -1);
    switch (optionObject.id) {
      case 0:
        setDynamicCommandOption(getSubModelsList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 1:
        setDynamicCommandOption(getFieldsList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 2:
        setDynamicCommandOption(getCategoryList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        setShowMath(true);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      default:
        let localRuleState = rule + " " + optionObject.label + " ";
        let localcondition = condition + " " + optionObject.label + " ";
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localcondition);
        setDynamicCommandOption([]);
        break;
    }
  };


  const handleUpdatePropNameToRuleScope = (
    optionObject: any,
    concatString: string
  ) => {
    const id = optionObject?.id
    const type = optionObject?.type
    const submodel = optionObject?.subModel ? optionObject?.subModel : hierarchyObject?.subModel
    const field = optionObject?.field ? optionObject?.field : hierarchyObject?.field
    setRuleScope({
      ...ruleScope,
      [`${propName + concatString}`]: { id: id, type: type, subModel: submodel, field: field },
    });

    setPropName(RULE_EMPTY_STRING);
    setHierarchyObject({ subModel: '', category: '', field: '' })
  };
  const handleSubOptionsCLick = (
    optionObject: commandType,
    callType: string = RULE_FUNCTION_EXPRESSION
  ) => {
    let localRuleState =
      callType === RULE_FUNCTION_EXPRESSION ? ruleState : conditionState;
    const addition = '"' + optionObject.label + '"';
    switch (optionObject.choiceType) {
      case RULE_FUNCTION_SUBMODEL:
        const submodelString = addition + ".";
        localRuleState = localRuleState + submodelString;
        setPropName(submodelString);
        setDynamicCommandOption(getSubModelsFieldsList(optionObject.id));
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, subModel: optionObject?.id }
          return newObj
        })
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD:
        localRuleState = localRuleState + addition;
        // const subModelFieldOptions = getSubModelsFieldsChoiceList(
        //   optionObject.id
        // );
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        setPropName(propName + addition);
        // if (!subModelFieldOptions)
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
        );
        setDynamicCommandOption([]);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        break;
      case RULE_FUNCTION_FIELD:
        const fieldOptions = getSubModelsFieldsChoiceList(optionObject.id);
        setPropName(propName + optionObject.label);
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        if (!fieldOptions)
          handleUpdatePropNameToRuleScope(
            optionObject,
            optionObject.label
          );
        setDynamicCommandOption(fieldOptions);
        if (callType === RULE_FUNCTION_EXPRESSION)
          setRuleState(localRuleState + optionObject.label);
        else setConditionState(localRuleState + optionObject.label);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD_CHOICE:
        const choiceString = "." + addition;
        localRuleState = localRuleState + choiceString;
        setPropName(propName + choiceString);
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString
        );
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
      case RULE_FUNCTION_CATEGORY:
        const choiceString2 = addition;
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString2
        );
        localRuleState = localRuleState + addition;
        setPropName(propName + localRuleState);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
      default:
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  const onChangeHandler = (
    e: any,
    type = RULE_FUNCTION_PARENT,
    callType = RULE_FUNCTION_EXPRESSION
  ) => {
    if (type === RULE_FUNCTION_CHILD) {
      if (e.includes(RULE_DONE)) {
        setShowMath(false);
        setActiveInput(callType);
        setFocusToInput(callType);
        return;
      }
      if (e.includes(RULE_ADD_FIELD)) {
        setShowMath(false);
        setShowSelectOptions(true);
        setDynamicCommandOption([]);
        setActiveInput(callType);
        setFocusToInput(callType);
        return;
      }
      if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(e);
      else setConditionState(e);
    } else {
      if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(e.target.value);
      else setConditionState(e.target.value);
    }
    setActiveInput(callType);
    setFocusToInput(callType);
  };

  const isValidMathExpression = (expression: string) => {
    try {
      const stack = [];
      const openingBrackets = ["(", "[", "{"];
      const closingBrackets = [")", "]", "}"];

      for (let i = 0; i < expression.length; i++) {
        const char = expression[i];

        if (openingBrackets.includes(char)) {
          stack.push(char);
        } else if (closingBrackets.includes(char)) {
          const correspondingOpeningBracket =
            openingBrackets[closingBrackets.indexOf(char)];

          if (
            stack.length === 0 ||
            stack.pop() !== correspondingOpeningBracket
          ) {
            return false;
          }
        }
      }

      return stack.length === 0;
    } catch (error) {
      return false;
    }
  };

  const onSaveHandler = async (
    type: string = RULE_FUNCTION_SAVE,
    paramRuleExpList: TRuleObj[]
  ) => {
    let localRules = [...rules];
    const localRuleExpList = paramRuleExpList.map((x) => {
      let newObj = { ...x };
      delete newObj.disabled;
      return newObj;
    });
    let message = RULE_EMPTY_STRING;
    if (type === RULE_FUNCTION_EDIT || type === RULE_FUNCTION_DELETE) {
      message = RULE_UPDATE_MESSAGE;
      localRules = rules?.map((x) => {
        let newObj = { ...x };
        if (x.id === editId) {
          newObj.ruleExpList = localRuleExpList;
          newObj.ruleScope = ruleScope;
          newObj.name = ruleName;
          newObj.description = description;
          newObj.operator = operator?.label;
          newObj.feature = feature?.id;
          newObj.featureType = stateFeatureType?.id;
          newObj.subModel = feature?.subModel;
        }
        return newObj;
      });
      if (type === RULE_FUNCTION_DELETE) updateRules(localRules);
    } else {
      message = RULE_SAVE_MESSAGE;
      localRules.push({
        ruleExpList: localRuleExpList,
        name: ruleName,
        description: description,
        type: ruleType,
        ruleScope: ruleScope,
        operator: operator?.label,
        feature: feature?.id,
        featureType: stateFeatureType?.id,
        subModel: feature?.subModel,
      });
    }
    if (ruleName) {
      if (ruleState && conditionState) {
        if (
          isValidMathExpression(ruleState) &&
          isValidMathExpression(conditionState)
        ) {
          setRules(localRules);
          updateRules(localRules);
          setLoading(true);
          await createISRProject(true);
          setLoading(false);
          resetState();
          setTimeout(() => {
            toast.success(message);
          }, 1000);
        } else {
          toast.info(RULE_VALIDATION_MESSAGE);
        }
      }
    } else toast.info(RULE_NAME_MANDATORY_MESSAGE);
  };

  const resetState = () => {
    setShowMath(false);
    setShowSelectOptions(false);
    setDynamicCommandOption([]);
    setRuleState(RULE_EMPTY_STRING);
    setConditionState(RULE_EMPTY_STRING);
  };

  const onInputChangeHandler = (e: any, type: string) => {
    if (type === RULE_FUNCTION_RULE_NAME) {
      setRuleName(e.target.value);
    } else {
      setDescription(e.target.value);
    }
  };

  const handleFeatureType = (e: any) => {
    const localFeatureType = RULE_FEATURE_TYPE_OPTIONS.filter(
      (x) => x?.id === e
    );
    setStateFeatureType(localFeatureType[0]);
    switch (e) {
      case RULE_FUNCTION_0:
        setDynamicFeatureOptions(getSubModelsList());
        break;
      case RULE_FUNCTION_1:
        setDynamicFeatureOptions(getFieldsList());
        break;
      case RULE_FUNCTION_2:
        setDynamicFeatureOptions(getCategoryList());
        break;
      case RULE_FUNCTION_3:
        setDynamicFeatureOptions(getConnectorList());
        break;
      default:
        break;
    }
  };

  const handleFeature = (e: any) => {
    const localFeature = (dynamicFeatureOptions as RuleOptionType[])?.filter(
      (x) => x?.id === e
    );
    setFeature(localFeature[0]);
  };

  const handleOperator = (e: any) => {
    const localOperator = RULE_OPERATOR_OPTIONS?.filter(
      (x) => `${x?.id}` === e
    );
    setOperator(localOperator[0]);
  };

  const handleEdit = async (id: string | undefined) => {
    const prevEdited = ruleExpList.filter((x) => x.disabled === false) ?? [];
    if(prevEdited.length > 0) {
      await handleDone(prevEdited[0].id, RULE_FUNCTION_SAVE)
    }
    const localRuleExpList = ruleExpList.map((x) => {
      if (x.id === id) {
        x.disabled = false;
        setConditionState(x.ruleCondition);
        setRuleState(x.ruleExp);
      } else x.disabled = true;
      return x;
    });
    setRuleExpList(localRuleExpList);
  };

  const handleDelete = (id: string | undefined) => {
    let localRuleExpList: TRuleObj[] = ruleExpList;
    setRuleExpList((prev) => {
      const next = prev?.filter((x) => x.id !== id);
      localRuleExpList = [...next];
      return next;
    });
    onSaveHandler(RULE_FUNCTION_DELETE, localRuleExpList);
    resetState();
  };

  const handleDone = async (
    id: string | undefined | null = undefined,
    callType: string = RULE_FUNCTION_SAVE
  ) => {
    if(loading) {
        toast.info('Please wait, saving rule...');
        return;
    }
    if(callType === RULE_FUNCTION_ADD) {
      const unsavedRules = ruleExpList?.filter((x) => x.id === undefined) ?? [];
      if(unsavedRules.length > 0) {
        toast.info('Please save rule to continue');
        return;
      }
    }
    let editFlag = false;
    const localRuleExpList =
      ruleExpList?.map((x) => {
        if (x.id && x.id === id) {
          if (conditionState) x.ruleCondition = conditionState;
          if (ruleState) x.ruleExp = ruleState;
          editFlag = true;
        } else {
          if (!editFlag && !x.ruleCondition && conditionState)
            x.ruleCondition = conditionState;
          if (!editFlag && !x.ruleExp && ruleState) x.ruleExp = ruleState;
        }
        x.disabled = true;
        return x;
      }) ?? [];
    if (callType === RULE_FUNCTION_ADD) {
      localRuleExpList?.push({
        ruleCondition: RULE_EMPTY_STRING,
        ruleExp: RULE_EMPTY_STRING,
      });
    }
    setRuleExpList(localRuleExpList);
    await onSaveHandler(
      editId ? RULE_FUNCTION_EDIT : RULE_FUNCTION_SAVE,
      localRuleExpList
    );
  };

  const saveRules = async () => {
    if (loading) {
      toast.info('Please wait, saving rule...');
      return;
    }
    let currentEditingRuleId: string | undefined | null = undefined;
    const currentEditingRules = ruleExpList?.filter((x) => x.disabled === false) ?? [];
    if (currentEditingRules.length > 0) {
      currentEditingRuleId = currentEditingRules[0].id;
    }
    let editFlag = false;
    const localRuleExpList =
        ruleExpList?.map((x) => {
          if (x.id && x.id === currentEditingRuleId) {
            if (conditionState) x.ruleCondition = conditionState;
            if (ruleState) x.ruleExp = ruleState;
            editFlag = true;
          } else {
            if (!editFlag && !x.ruleCondition && conditionState)
              x.ruleCondition = conditionState;
            if (!editFlag && !x.ruleExp && ruleState) x.ruleExp = ruleState;
          }
          x.disabled = true;
          return x;
        }) ?? [];
    if (!ruleName) {
      toast.info(RULE_NAME_MANDATORY_MESSAGE)
      return;
    }
    let message = RULE_SAVE_MESSAGE;
    let localRules = [...rules];
    const ruleIndex = localRules.findIndex((x) => x.id === editId);
    if (ruleIndex >= 0) {
      localRules[ruleIndex].ruleExpList = ruleExpList;
      localRules[ruleIndex].name = ruleName;
      localRules[ruleIndex].description = description;
      localRules[ruleIndex].type = ruleType;
      localRules[ruleIndex].ruleScope = ruleScope;
      localRules[ruleIndex].operator = operator?.label;
      localRules[ruleIndex].feature = feature?.id;
      localRules[ruleIndex].featureType = stateFeatureType?.id;
      localRules[ruleIndex].subModel = feature?.subModel;
    } else {
      localRules.push({
        ruleExpList: localRuleExpList,
        name: ruleName,
        description: description,
        type: ruleType,
        ruleScope: ruleScope,
        operator: operator?.label,
        feature: feature?.id,
        featureType: stateFeatureType?.id,
        subModel: feature?.subModel,
      });
    }
    setRules(localRules);
    updateRules(localRules);
    setLoading(true);
    await createISRProject(true);
    setLoading(false);
    setTimeout(() => {
      toast.success(message);
    }, 1000);
    setRuleExpList(localRuleExpList);
  };

  return (
    <div className="cart-style-dm tw-bg-gray-100 tw-w-full tw-h-screen">
      <label className="cart-title tw-m-2">
        {RULE_NAME}
        <span className="tw-text-red-500 tw-ml-4">{RULE_STAR}</span>
      </label>
      <input
        className="tw-h-8 tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-rounded-sm tw-ml-2"
        value={ruleName}
        onChange={(e) => onInputChangeHandler(e, RULE_FUNCTION_RULE_NAME)}
      />
      <label className="cart-title tw-m-2">{RULE_DESCRIPTION}</label>
      <input
        className="tw-h-8 tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-rounded-sm tw-ml-2"
        value={description}
        onChange={(e) => onInputChangeHandler(e, RULE_FUNCTION_DESCRIPTION)}
      />
      <div className="tw-flex tw-w-full tw-rounded-md tw-mt-4 tw-gap-4">
        <div className="tw-w-[30%] tw-ml-2 ">
          <label className="cart-title tw-mt-2">{RULE_FEATURE_TYPE}</label>
          <select
            className="drop-down-dm"
            value={stateFeatureType?.id}
            onChange={(e) => handleFeatureType(e.target.value)}
            // disabled={editId? true: false}
            disabled={false}
          >
            <option>{RULE_SELECT}</option>
            {RULE_FEATURE_TYPE_OPTIONS?.map((item, index) => {
              return (
                <option value={item?.id ?? RULE_EMPTY_STRING} key={item?.id}>
                  {item?.label ?? RULE_EMPTY_STRING}
                </option>
              );
            })}
          </select>
        </div>
        <div className="tw-w-[30%] tw-ml-2 ">
          <label className="cart-title tw-mt-2">{RULE_FEATURE}</label>
          <select
            className="drop-down-dm"
            value={feature?.id}
            onChange={(e) => handleFeature(e.target.value)}
            disabled={false}
          >
            <option>{RULE_SELECT}</option>
            {dynamicFeatureOptions?.map((item, index) => {
              return (
                <option value={item?.id ?? RULE_EMPTY_STRING} key={item?.id}>
                  {item?.label}
                </option>
              );
            })}
          </select>
        </div>
        <div className="tw-w-[30%] tw-ml-4 ">
          <label className="cart-title tw-mt-2">{RULE_OPERATOR}</label>
          <select
            className="drop-down-dm"
            value={operator?.id}
            onChange={(e) => handleOperator(e.target.value)}
          >
            <option>{RULE_SELECT}</option>
            {RULE_OPERATOR_OPTIONS?.map((item, index) => {
              return (
                <option value={item?.id ?? RULE_EMPTY_STRING} key={item?.id}>
                  {item?.label ?? RULE_EMPTY_STRING}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="tw-flex tw-md:flex tw-md:flex-grow tw-flex-row tw-justify-end tw-mt-3 tw-me-[55px]">
        <button
            className="tw-rounded tw-text-blue  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-4 tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
            onClick={() => saveRules()}
        >
          {RULE_SAVE}
        </button>
      </div>
      <div>
        <label className="cart-title tw-ml-2 tw-mt-2">{RULE_RULE}</label>
        {ruleExpList?.map((x, i) => (
          <div
            key={i}
            className="border tw-p-4 tw-w-full tw-h-full tw-bg-shades-of-grey-10 tw-justify-center tw-items-center tw-rounded-md tw-border-zinc-200 tw-mt-4 tw-gap-4"
          >
            <div>
              <div className="tw-w-[100%] tw-flex tw-flex-row ">
                <label className="tw-w-[90%]">{RULE_EXPRESSION}</label>
                <button
                  className="tw-rounded  tw-text-blue tw-mr-1  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-w-[10%] tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
                  onClick={() => {
                    x?.disabled
                      ? handleEdit(x.id)
                      : handleDone(x.id, RULE_FUNCTION_SAVE);
                  }}
                >
                  {x?.disabled ? <EditIcon /> : RULE_DONE}
                </button>
                <button
                  className="tw-rounded tw-text-white  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-w-[10%] tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
                  onClick={() => {
                    handleDelete(x?.id);
                  }}
                >
                  <DeleteIcon />
                </button>
              </div>
              <div className=" tw-bg-shades-of-grey-10 tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60   focus:tw-outline-none">
                <textarea
                  className="tw-h-8 tw-rounded tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-solid tw-border-shades-of-grey-30 tw-border-[1px]"
                  disabled={x?.disabled}
                  value={!x?.disabled ? ruleState : x?.ruleExp}
                  onChange={(e) => onChangeHandler(e, RULE_FUNCTION_PARENT)}
                  ref={(el) => setExpressionRef(el)}
                />
              </div>
            </div>
            <div>
              <label>{RULE_CONDITION}</label>
              <div className=" tw-bg-shades-of-grey-10 tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60   focus:tw-outline-none">
                <textarea
                  className="tw-h-8 tw-rounded tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-solid tw-border-shades-of-grey-30 tw-border-[1px]"
                  value={!x?.disabled ? conditionState : x?.ruleCondition}
                  disabled={x?.disabled}
                  onChange={(e) =>
                    onChangeHandler(
                      e,
                      RULE_FUNCTION_PARENT,
                      RULE_FUNCTION_CONDITION
                    )
                  }
                  ref={(el) => setConditionRef(el)}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          onClick={() => handleDone(null, RULE_FUNCTION_ADD)}
          className={`tw-mt-2 tw-rounded  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
        >
          {CREATE_NEW_CONDITION}
        </button>
      </div>
      {showMath && (
        <MathOperator
          state={
            activeInput === RULE_FUNCTION_EXPRESSION
              ? ruleState
              : conditionState
          }
          handleState={(e: string) =>
            onChangeHandler(e, RULE_FUNCTION_CHILD, activeInput)
          }
        />
      )}
      {showSelectOptions && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={commandOptions}
            onClickHandler={(option: any) => {
              handleOptionsClick(option, activeInput);
            }}
          />
        </div>
      )}
      {dynamicCommandOption && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={dynamicCommandOption}
            onClickHandler={(option: any) => {
              handleSubOptionsCLick(option, activeInput);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ConditionalRuleComponent;
